import React from 'react';

export interface IDisabledActionWrapper {
    children: React.ReactNode;
    disabled?: boolean;
    onDisabledClick?: () => void;
    className?: string;
}

export function DisabledActionWrapper({
    children,
    disabled,
    onDisabledClick,
}: IDisabledActionWrapper) {
    const onClick = (event: React.MouseEvent<HTMLElement>) => {
        if (disabled) {
            event.stopPropagation();
            onDisabledClick?.();
        }
    };

    return <div onClick={onClick}>{children}</div>;
}
